// Descrição: Alerta exibido no sidebar para usuários que não finalizaram o cadastro

import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import { useNavigate } from 'react-router-dom'; 

export default function CardAlert() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/finalizar-cadastro');
  };

  return (
    <Card variant="outlined" sx={{ m: 1.5, flexShrink: 0 }}>
      <CardContent>
        <AutoAwesomeRoundedIcon fontSize="small" />
        <Typography gutterBottom sx={{ fontWeight: 600 }}>
          Finalize seu cadastro
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
          E comece a usar o sistema com 20% de desconto na primeira mensalidade.
        </Typography>
        <Button variant="contained" size="small" fullWidth onClick={handleClick}>
          Finalizar cadastro
        </Button>
      </CardContent>
    </Card>
  );
}